
// import React, { useState, useEffect } from "react";
// import { Modal, Button, Spinner } from "react-bootstrap";
// import { toast } from "react-toastify";
// import { getDatabase, ref, get, set, update, onValue, query, orderByChild, equalTo } from "firebase/database";
// import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, updateProfile } from "firebase/auth";
// import { app } from "../../../Doctor/Firebase/firebase.config";
// import { useAuth } from "../../AuthContext";
// import emailjs from "@emailjs/browser";

// const database = getDatabase(app);
// const auth = getAuth(app);

// const EMAILJS_SERVICE_ID               = 'service_cab38e6';
// const EMAILJS_OTP_TEMPLATE_ID          = 'template_h08g4fm';
// const EMAILJS_CONFIRMATION_TEMPLATE_ID = 'template_c2m3r4j';
// const EMAILJS_PUBLIC_KEY               = 'rnBYIQUEQDDpqOcl1';

// /* ── Inject scrollbar + responsive CSS once ── */
// const MODAL_CSS = `
//   .tsm-body::-webkit-scrollbar { width: 4px; }
//   .tsm-body::-webkit-scrollbar-track { background: #eef2ff; border-radius: 10px; }
//   .tsm-body::-webkit-scrollbar-thumb { background: #4285f4; border-radius: 10px; }
//   .tsm-body::-webkit-scrollbar-thumb:hover { background: #2563eb; }
//   .tsm-wrap .modal-dialog { margin: 6px auto !important; max-width: 500px !important; }
//   .tsm-wrap .modal-content {
//     border-radius: 14px !important; border: none !important; overflow: hidden !important;
//     max-height: calc(100dvh - 12px) !important; display: flex !important;
//     flex-direction: column !important; box-shadow: 0 10px 40px rgba(0,0,0,0.15) !important;
//   }
//   @media (max-width: 576px) {
//     .tsm-wrap .modal-dialog { margin: 4px !important; max-width: calc(100vw - 8px) !important; }
//     .tsm-wrap .modal-content { max-height: calc(100dvh - 8px) !important; border-radius: 12px !important; }
//     .tsm-slots-grid { grid-template-columns: repeat(auto-fill, minmax(75px, 1fr)) !important; gap: 6px !important; }
//     .tsm-otp-inputs { gap: 8px !important; }
//     .tsm-share-btns { flex-direction: column !important; }
//   }
// `;
// if (typeof document !== 'undefined' && !document.getElementById('tsm-css')) {
//   const s = document.createElement('style'); s.id = 'tsm-css'; s.textContent = MODAL_CSS;
//   document.head.appendChild(s);
// }

// /* ── Style tokens ── */
// const S = {
//   header: { background: 'linear-gradient(135deg,#4285f4 0%,#34a853 100%)', padding: '12px 16px', borderBottom: 'none', flexShrink: 0 },
//   avatar: { width: 40, height: 40, borderRadius: '50%', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, fontWeight: 700, color: '#4285f4', flexShrink: 0 },
//   docName: { fontSize: 15, fontWeight: 600, margin: 0, color: '#fff' },
//   docSpec: { fontSize: 12, opacity: .88, margin: 0, color: '#fff' },
//   body: { padding: '12px 14px', background: '#f4f6fb', overflowY: 'auto', overflowX: 'hidden', flex: '1 1 auto', scrollbarWidth: 'thin', scrollbarColor: '#4285f4 #eef2ff' },
//   progWrap: { display: 'flex', justifyContent: 'space-between', background: '#fff', padding: '10px 12px', borderRadius: 10, marginBottom: 12, boxShadow: '0 1px 6px rgba(0,0,0,.06)' },
//   progStep: { flex: 1, textAlign: 'center' },
//   circle: (st) => ({
//     width: 28, height: 28, borderRadius: '50%', margin: '0 auto 3px',
//     display: 'flex', alignItems: 'center', justifyContent: 'center',
//     fontWeight: 700, fontSize: 12, transition: 'all .25s',
//     background: st === 'active' ? '#4285f4' : st === 'done' ? '#34a853' : '#e5e7eb',
//     color: st !== 'idle' ? '#fff' : '#9ca3af',
//     boxShadow: st === 'active' ? '0 2px 8px rgba(66,133,244,.35)' : 'none',
//   }),
//   circleLabel: (st) => ({ fontSize: 9, fontWeight: st === 'active' ? 700 : 500, color: st === 'active' ? '#4285f4' : st === 'done' ? '#34a853' : '#9ca3af' }),
//   card: { background: '#fff', borderRadius: 10, padding: '14px', boxShadow: '0 1px 8px rgba(0,0,0,.06)' },
//   cardTitle: { fontSize: 14, fontWeight: 700, color: '#1e293b', borderBottom: '2px solid #4285f4', paddingBottom: 8, marginBottom: 12 },
//   sessionBar: { background: '#f1f5f9', padding: '7px 10px', borderRadius: 7, fontWeight: 600, fontSize: 12, color: '#334155', marginBottom: 8 },
//   breakBar: { background: '#fef9c3', padding: '7px 10px', borderRadius: 7, fontWeight: 600, fontSize: 12, color: '#854d0e', textAlign: 'center', margin: '8px 0', border: '1px solid #fde68a' },
//   slot: (sel, booked) => ({
//     padding: '7px 4px', borderRadius: 7, fontSize: 11, fontWeight: 600, textAlign: 'center',
//     minHeight: 38, cursor: booked ? 'not-allowed' : 'pointer', transition: 'all .18s', lineHeight: 1.3,
//     border: sel ? '2px solid #4285f4' : '1.5px solid #e2e8f0',
//     background: booked ? '#f9fafb' : sel ? '#4285f4' : '#fff',
//     color: booked ? '#d1d5db' : sel ? '#fff' : '#374151',
//     textDecoration: booked ? 'line-through' : 'none',
//   }),
//   label: { fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 },
//   input: { width: '100%', padding: '8px 10px', fontSize: 13, border: '1.5px solid #e2e8f0', borderRadius: 7, outline: 'none', transition: 'border .2s', boxSizing: 'border-box' },
//   textarea: { width: '100%', padding: '8px 10px', fontSize: 12, border: '1.5px solid #e2e8f0', borderRadius: 7, minHeight: 72, fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box' },
//   err: { color: '#ef4444', fontSize: 11, marginTop: 3 },
//   highlight: { background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, padding: '8px 10px', fontSize: 12, marginBottom: 10 },
//   health: { background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 8, padding: '10px 12px', marginTop: 8 },
//   authBanner: (type) => ({
//     display: 'flex', alignItems: 'flex-start', gap: 8, padding: '8px 12px',
//     borderRadius: 8, marginBottom: 12, fontSize: 12,
//     background: type === 'new' ? '#f0fdf4' : type === 'existing' ? '#eff6ff' : '#fef9c3',
//     border: `1px solid ${type === 'new' ? '#bbf7d0' : type === 'existing' ? '#bfdbfe' : '#fde68a'}`,
//     color: type === 'new' ? '#15803d' : type === 'existing' ? '#1d4ed8' : '#854d0e',
//   }),
//   sumCard: { borderRadius: 10, overflow: 'hidden', border: '1px solid #e2e8f0' },
//   sumSec: { padding: '10px 14px', borderBottom: '1px solid #f1f5f9' },
//   sumTitle: { fontSize: 13, fontWeight: 700, color: '#1e293b', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 },
//   sumRow: { display: 'flex', justifyContent: 'space-between', padding: '5px 0', borderBottom: '1px solid #f8fafc' },
//   sumLbl: { fontSize: 12, color: '#6b7280', fontWeight: 500 },
//   sumVal: { fontSize: 12, color: '#1e293b', fontWeight: 600, textAlign: 'right', maxWidth: '55%', wordBreak: 'break-word' },
//   shareBox: { border: '1.5px solid #bfdbfe', borderRadius: 10, padding: '14px', marginBottom: 12, background: 'linear-gradient(135deg,#eff6ff,#f0fdf9)' },
//   shareTitle: { fontSize: 14, fontWeight: 700, color: '#1e3a8a', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 8 },
//   shareSub: { fontSize: 12, color: '#64748b', marginBottom: 12, lineHeight: 1.5 },
//   docCard: (sel) => ({ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', borderRadius: 8, marginBottom: 8, border: sel ? '1.5px solid #4285f4' : '1.5px solid #e2e8f0', background: sel ? '#eff6ff' : '#fff', cursor: 'pointer', transition: 'all .18s' }),
//   docCheck: (sel) => ({ width: 20, height: 20, borderRadius: '50%', flexShrink: 0, border: '2px solid #4285f4', display: 'flex', alignItems: 'center', justifyContent: 'center', background: sel ? '#4285f4' : '#fff', color: '#fff', fontSize: 11 }),
//   btnPrimary: { background: '#4285f4', border: 'none', borderRadius: 8, padding: '9px 20px', fontSize: 13, fontWeight: 600, color: '#fff' },
//   btnSuccess: { background: '#34a853', border: 'none', borderRadius: 8, padding: '9px 20px', fontSize: 13, fontWeight: 600, color: '#fff', width: '100%' },
//   footer: { background: '#fff', padding: '10px 16px', borderTop: '1px solid #e2e8f0', flexShrink: 0 },
// };

// /* ── Helpers ── */
// const generateTimeSlots = (startTime, endTime) => {
//   const slots = [];
//   const parse = (t) => { if (!t) return null; const [h,m]=t.split(':').map(Number); const d=new Date(); d.setHours(h,m||0,0,0); return d; };
//   const start = parse(startTime), end = parse(endTime);
//   if (!start || !end || end <= start) return slots;
//   const cur = new Date(start);
//   while (cur < end) {
//     const h=cur.getHours(), m=cur.getMinutes(), ap=h>=12?'PM':'AM';
//     const dh=h%12||12, dm=m<10?'0'+m:m;
//     slots.push({ display:`${dh}:${dm} ${ap}`, value:`${dh}:${dm} ${ap}`, time24:`${String(h).padStart(2,'0')}:${dm}` });
//     cur.setTime(cur.getTime()+15*60000);
//   }
//   return slots;
// };

// const needsBreak = (me, es) => {
//   if (!me||!es) return false;
//   const p=(t)=>{const[h,m]=t.split(':').map(Number);const d=new Date();d.setHours(h,m||0,0,0);return d;};
//   return (p(es)-p(me))/(1000*60)>=30;
// };

// const fileIcon = (ft, fn) => {
//   const t=ft||'', n=(fn||'').toLowerCase();
//   if (t.includes('pdf')||n.endsWith('.pdf')) return '📋';
//   if (t.includes('image')||n.match(/\.(jpg|jpeg|png|webp)$/)) return '🖼️';
//   if (n.match(/\.(doc|docx)$/)) return '📝';
//   return '📄';
// };

// /* ────────────────────────────────────────────────────────────
//    ensureAccount
//    Returns { userId, isNewUser }
//    Strategy:
//    1. Already logged-in user → use their uid directly
//    2. Query DB by email → existing account found → sign in + return uid
//    3. Try sign in with temp password → success → return uid
//    4. Create new Firebase Auth account → save to DB → isNewUser=true
//    NO GUEST FALLBACK — if all fail, throw so caller can show error
// ──────────────────────────────────────────────────────────── */
// const ensureAccount = async (emailAddr, phonNum, fullName) => {
//   const tempPwd = `TD@${phonNum}#Trusty`;

//   // 1. Check if already signed in
//   if (auth.currentUser) {
//     const uid = auth.currentUser.uid;
//     return { userId: uid, isNewUser: false };
//   }

//   // 2. Check DB for existing user with this email
//   try {
//     const snap = await get(
//       query(ref(database, 'users'), orderByChild('email'), equalTo(emailAddr))
//     );
//     if (snap.exists()) {
//       const uid = Object.keys(snap.val())[0];
//       // Try silent sign-in so Firebase Auth state is live
//       try {
//         await signInWithEmailAndPassword(auth, emailAddr, tempPwd);
//       } catch (_) {
//         // Sign-in might fail if password differs — that's ok,
//         // we still have the uid from DB
//       }
//       return { userId: uid, isNewUser: false };
//     }
//   } catch (e) {
//     console.warn('DB email lookup error:', e);
//   }

//   // 3. Try signing in (handles case where Auth exists but DB record missing)
//   try {
//     const cred = await signInWithEmailAndPassword(auth, emailAddr, tempPwd);
//     const uid = cred.user.uid;
//     // Recreate DB record just in case it was missing
//     await set(ref(database, `users/${uid}`), {
//       userId: uid, name: fullName, email: emailAddr, mobile: phonNum,
//       accountType: 'patient', createdAt: new Date().toISOString(),
//     });
//     return { userId: uid, isNewUser: false };
//   } catch (signInErr) {
//     // auth/user-not-found or auth/invalid-credential = new user, continue
//     // auth/wrong-password = account exists with different password, handle below
//     if (signInErr.code !== 'auth/user-not-found' &&
//         signInErr.code !== 'auth/invalid-credential' &&
//         signInErr.code !== 'auth/wrong-password') {
//       throw signInErr; // unexpected error — bubble up
//     }
//   }

//   // 4. Create brand new account
//   try {
//     const cred = await createUserWithEmailAndPassword(auth, emailAddr, tempPwd);
//     const uid = cred.user.uid;
//     try { await updateProfile(cred.user, { displayName: fullName }); } catch (_) { /* ignore */ }
//     await set(ref(database, `users/${uid}`), {
//       userId: uid, name: fullName, email: emailAddr, mobile: phonNum,
//       accountType: 'patient', createdAt: new Date().toISOString(), autoCreated: true,
//     });
//     return { userId: uid, isNewUser: true };
//   } catch (createErr) {
//   if (createErr.code === 'auth/email-already-in-use') {
//   // User already has an account — silently sign them in with temp password
//   try {
//     const cred = await signInWithEmailAndPassword(auth, emailAddr, tempPwd);
//     return { userId: cred.user.uid, isNewUser: false };
//   } catch (_) {
//     // Password may have changed — check if already signed in
//     const currentUid = auth.currentUser?.uid;
//     if (currentUid) return { userId: currentUid, isNewUser: false };
//     // Last resort — look up uid from DB
//     try {
//       const snap = await get(
//         query(ref(database, 'users'), orderByChild('email'), equalTo(emailAddr))
//       );
//       if (snap.exists()) {
//         const uid = Object.keys(snap.val())[0];
//         return { userId: uid, isNewUser: false };
//       }
//     } catch (_) {}
//     // Can't authenticate but we have their info — generate a uid from email
//     // so booking still works (they verified via OTP already)
//     throw new Error('Please log in first to book another appointment.');
//   }
// }

//     throw createErr;
//   }
// };

// /* ── Component ── */
// const TimeSlotModal = ({ show, handleClose, bookingData, onBack, onBookingComplete }) => {
//   const { user, setUser } = useAuth();

//   const [step, setStep]                   = useState(1);
//   const [loading, setLoading]             = useState(false);
//   const [loadingSlots, setLoadingSlots]   = useState(false);
//   const [otpSent, setOtpSent]             = useState(false);
//   const [generatedOTP, setGeneratedOTP]   = useState('');
//   const [resolvedUserId, setResolvedUserId] = useState(null);
//   const [accountStatus, setAccountStatus]   = useState(null); // 'new' | 'existing'

//   const [selectedSlot, setSelectedSlot] = useState('');
//   const [allMorning, setAllMorning]     = useState([]);
//   const [allEvening, setAllEvening]     = useState([]);
//   const [bookedSlots, setBookedSlots]   = useState([]);
//   const [showBreak, setShowBreak]       = useState(false);

//   const [phoneNumber, setPhoneNumber] = useState('');
//   const [email, setEmail]             = useState('');
//   const [otp, setOtp]                 = useState(['','','','','','']);
//   const [phoneError, setPhoneError]   = useState('');
//   const [emailError, setEmailError]   = useState('');
//   const [nameError, setNameError]     = useState('');

//   const [patientName, setPatientName] = useState('');
//   const [patientAge, setPatientAge]   = useState('');
//   const [ageError, setAgeError]       = useState('');
//   const [healthIssues, setHealthIssues] = useState('');
//   const [medHistory, setMedHistory]     = useState('');
//   const [curMeds, setCurMeds]           = useState('');

//   const [patientDocs, setPatientDocs]       = useState([]);
//   const [loadingDocs, setLoadingDocs]       = useState(false);
//   const [wantsToShare, setWantsToShare]     = useState(null);
//   const [selectedDocIds, setSelectedDocIds] = useState([]);

//   /* fetch docs */
//   useEffect(() => {
//     if (!show) return;
//     const uid = resolvedUserId || user?.userId || user?.uid;
//     if (!uid) return;
//     setLoadingDocs(true);
//     const unsub = onValue(ref(database, `users/${uid}/reports`), snap => {
//       const data = snap.val();
//       setPatientDocs(data
//         ? Object.entries(data).map(([k,v])=>({reportId:k,...v})).sort((a,b)=>new Date(b.uploadedAt)-new Date(a.uploadedAt))
//         : []);
//       setLoadingDocs(false);
//     });
//     return () => unsub();
//   }, [show, user, resolvedUserId]);

//   /* fetch booked slots */
//   useEffect(() => {
//     if (!show || !bookingData?.doctor) return;
//     (async () => {
//       try {
//         setLoadingSlots(true);
//         const snap = await get(ref(database, `doctor/${bookingData.doctor.uid}/appointments`));
//         setBookedSlots(snap.exists() ? Object.values(snap.val()) : []);
//       } catch { toast.error('Failed to load slots'); }
//       finally { setLoadingSlots(false); }
//     })();
//   }, [show, bookingData]);

//   /* build slots */
//   useEffect(() => {
//     if (!bookingData?.schedule) { setAllMorning([]); setAllEvening([]); return; }
//     const { morningStartTime:ms, morningEndTime:me, eveningStartTime:es, eveningEndTime:ee } = bookingData.schedule;
//     const morning = ms && me ? generateTimeSlots(ms, me) : [];
//     const evening = es && ee ? generateTimeSlots(es, ee) : [];
//     setShowBreak(needsBreak(me, es));
//     const fmt = bookingData.date.toLocaleDateString('en-US',{year:'numeric',month:'2-digit',day:'2-digit'});
//     const mark = slots => slots.map(sl => ({
//       ...sl,
//       isBooked: bookedSlots.some(b => {
//         if (!b.date||!b.timeSlot) return false;
//         const bd = new Date(b.date).toLocaleDateString('en-US',{year:'numeric',month:'2-digit',day:'2-digit'});
//         return bd === fmt && b.timeSlot === sl.value;
//       }),
//     }));
//     setAllMorning(mark(morning));
//     setAllEvening(mark(evening));
//   }, [bookingData, bookedSlots]);

//   const toggleDoc = id => setSelectedDocIds(p => p.includes(id) ? p.filter(x=>x!==id) : [...p,id]);

//   /* ── Send OTP ── */
//   const sendOTP = async () => {
//     setPhoneError(''); setEmailError(''); setNameError('');
//     if (!patientName.trim()) { setNameError('Name required'); toast.error('Enter patient name'); return; }
//     if (!phoneNumber.trim()) { setPhoneError('Phone required'); return; }
//     if (!/^[6-9]\d{9}$/.test(phoneNumber)) { setPhoneError('Invalid 10-digit number'); return; }
//     if (!email.trim()) { setEmailError('Email required'); return; }
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setEmailError('Invalid email'); return; }
//     setLoading(true);
//     const code = Math.floor(100000 + Math.random()*900000).toString();
//     setGeneratedOTP(code);
//     try {
//       const expiry = new Date(); expiry.setMinutes(expiry.getMinutes()+15);
//       const expiryStr = expiry.toLocaleTimeString('en-US',{hour:'2-digit',minute:'2-digit',hour12:true});
//       await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_OTP_TEMPLATE_ID, {
//         to_email:email, to_name:patientName||'Patient', passcode:code, otp:code, OTP:code,
//         time:expiryStr, expiry_time:expiryStr,
//         doctor_name:`Dr. ${bookingData?.doctor?.First||''} ${bookingData?.doctor?.Last||''}`,
//         appointment_date: bookingData?.date?.toLocaleDateString('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric'})||'',
//         appointment_time:selectedSlot,
//       }, EMAILJS_PUBLIC_KEY);
//       setOtpSent(true);
//       toast.success(`OTP sent to ${email}`);
//     } catch {
//       toast.error('OTP send failed');
//       toast.info(`Dev OTP: ${code}`, {autoClose:false});
//     } finally { setLoading(false); }
//   };

//   /* ── Verify OTP → auto-register / auto-login ── */
//   const verifyOTP = async () => {
//     if (otp.join('') !== generatedOTP) { toast.error('Wrong OTP. Try again.'); return; }
//     setLoading(true);

//     try {
//       // If already logged in, use existing session
//       const existingUid = user?.userId || user?.uid || auth.currentUser?.uid;
//       if (existingUid) {
//         setResolvedUserId(existingUid);
//         setAccountStatus('existing');
//         toast.success('OTP verified! Continuing with your account.');
//         setStep(3);
//         setLoading(false);
//         return;
//       }

//       toast.info('OTP verified! Setting up your account…', { autoClose: 2000 });

//       // ✅ NO GUEST FALLBACK — ensureAccount will throw if it can't get a real uid
//       const { userId, isNewUser } = await ensureAccount(email, phoneNumber, patientName);

//       setResolvedUserId(userId);
//       setAccountStatus(isNewUser ? 'new' : 'existing');

//       // Update AuthContext so the rest of the app sees the user as logged in
//       if (typeof setUser === 'function') {
//         setUser({ userId, uid: userId, email, name: patientName, mobile: phoneNumber });
//       }

//       if (isNewUser) {
//         toast.success('✅ Account created! Temporary password sent to your email.');
//         try {
//           await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_OTP_TEMPLATE_ID, {
//             to_email: email,
//             to_name: patientName,
//             passcode: `TD@${phoneNumber}#Trusty`,
//             otp: `Your TrustDoctor account has been created.\nTemporary password: TD@${phoneNumber}#Trusty\nPlease change it after logging in.`,
//             OTP: `TD@${phoneNumber}#Trusty`,
//             time: 'first login',
//             expiry_time: 'first login',
//           }, EMAILJS_PUBLIC_KEY);
//         } catch (_) { /* non-critical */ }
//       } else {
//         toast.info('👋 Welcome back! Continuing with your existing account.');
//       }

//       setStep(3);

//     } catch (err) {
//       // ✅ SHOW ERROR TO USER — do NOT silently fall back to guest
//       console.error('Account setup error:', err);
//       const msg = err.message || 'Account setup failed. Please try again.';
//       toast.error(msg);
//       // Stay on step 2 so user can retry — do NOT advance to step 3
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleOtpChange = (i, v) => {
//     if (!/^\d*$/.test(v)) return;
//     const n=[...otp]; n[i]=v; setOtp(n);
//     if (v && i<5) document.getElementById(`tsm-otp-${i+1}`)?.focus();
//   };
//   const handleOtpKey = (i, e) => {
//     if (e.key==='Backspace' && !otp[i] && i>0) document.getElementById(`tsm-otp-${i-1}`)?.focus();
//   };

//   const confirmBooking = () => {
//     setNameError(''); setAgeError('');
//     if (!patientName.trim()) { setNameError('Name required'); return; }
//     if (!patientAge.trim()) { setAgeError('Age required'); return; }
//     if (isNaN(patientAge)||+patientAge<0||+patientAge>150) { setAgeError('Invalid age'); return; }
//     setStep(3.5);
//   };

//   /* ── Finalize booking ── */
//   const finalizeBooking = async () => {
//     const activeUserId = resolvedUserId || user?.userId || user?.uid;

//     // ✅ BLOCK booking if no real authenticated user id
//     if (!activeUserId || activeUserId.startsWith('guest_')) {
//       toast.error('Authentication required. Please verify your OTP again.');
//       setStep(2);
//       setOtpSent(false);
//       return;
//     }

//     if (!selectedSlot) { toast.error('No slot selected'); return; }
//     setLoading(true);
//     try {
//       // Each booking gets a unique ID — allows same patient to book multiple times
//       const aptId = `apt_${Date.now()}_${Math.random().toString(36).substr(2,9)}`;
//       const aptDate = bookingData.date.toLocaleDateString('en-US',{year:'numeric',month:'2-digit',day:'2-digit'});
//       const sharedDocs = wantsToShare && selectedDocIds.length
//         ? patientDocs.filter(d=>selectedDocIds.includes(d.reportId)).map(d=>({
//             reportId:d.reportId, fileName:d.fileName||'Doc', description:d.description||'',
//             fileType:d.fileType||'', fileSizeMB:d.fileSizeMB||'', uploadedAt:d.uploadedAt||'', fileData:d.fileData||'',
//           }))
//         : [];

//       const apt = {
//         appointmentId:aptId, id:aptId,
//         patientID:activeUserId,
//         patientName:patientName.trim(), patientAge:patientAge.trim(),
//         patientPhone:phoneNumber.trim(), patientEmail:email.trim(), patientMobile:phoneNumber.trim(),
//         date:aptDate, appointmentDate:aptDate,
//         timeSlot:selectedSlot, appointmentTime:selectedSlot,
//         symptoms:healthIssues.trim()||'Not provided', healthIssues:healthIssues.trim()||'Not provided',
//         description:healthIssues.trim()||'Not provided',
//         medicalHistory:medHistory.trim()||'None', currentMedications:curMeds.trim()||'None', medications:curMeds.trim()||'None',
//         doctorId:bookingData.doctor.uid, doctorUID:bookingData.doctor.uid,
//         doctorName:`Dr. ${bookingData.doctor.First} ${bookingData.doctor.Last}`,
//         speciality:bookingData.doctor.Speciality||'General Physician',
//         clinicName:bookingData.doctor.ClinicName||"Doctor's Clinic",
//         status:'Confirmed', paymentStatus:'Pending', paymentMethod:'Not specified',
//         bookingDate:new Date().toISOString(), createdAt:new Date().toISOString(), updatedAt:new Date().toISOString(),
//         accountAutoCreated: accountStatus === 'new',
//         sharedDocuments:sharedDocs, hasSharedDocuments:sharedDocs.length>0, sharedDocumentCount:sharedDocs.length,
//       };

//       // ✅ Both writes use real Firebase uid — no permission errors
//       await set(ref(database,`doctor/${bookingData.doctor.uid}/appointments/${aptId}`), apt);
//       await set(ref(database,`users/${activeUserId}/appointments/${aptId}`), apt);

//       try {
//         await update(ref(database,`users/${activeUserId}`), {
//           name:patientName.trim(), email:email.trim(), mobile:phoneNumber.trim(),
//           age:patientAge.trim(), updatedAt:new Date().toISOString(),
//         });
//       } catch (_) { /* non-critical */ }

//       try {
//         await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_CONFIRMATION_TEMPLATE_ID, {
//           Patient_Email:email, Patient_Name:patientName,
//           Doctor_Name:`Dr. ${bookingData.doctor.First} ${bookingData.doctor.Last}`,
//           Apn_Date:bookingData.date.toLocaleDateString('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric'}),
//           Apn_Time:selectedSlot, Doctor_Speciality:bookingData.doctor.Speciality,
//           Clinic_Name:bookingData.doctor.ClinicName||"Doctor's Clinic",
//           Appointment_ID:aptId,
//           Booking_Date:new Date().toLocaleDateString('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric'}),
//         }, EMAILJS_PUBLIC_KEY);
//       } catch (_) { toast.warning('Booked! But confirmation email failed.'); }

//       toast.success('🎉 Appointment booked successfully!');
//       resetForm();
//       onBookingComplete?.();
//       setTimeout(()=>handleModalClose(), 2000);
//     } catch (e) {
//       console.error(e); toast.error('Booking failed. Please try again.');
//     } finally { setLoading(false); }
//   };

//   const resetForm = () => {
//     setPatientName(''); setPatientAge(''); setPhoneNumber(''); setEmail('');
//     setHealthIssues(''); setMedHistory(''); setCurMeds('');
//     setSelectedSlot(''); setOtpSent(false); setOtp(['','','','','','']);
//     setStep(1); setWantsToShare(null); setSelectedDocIds([]);
//     setResolvedUserId(null); setAccountStatus(null);
//   };

//   const handleModalClose = () => { resetForm(); handleClose(); };
//   const fmtDate = d => d?.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric',year:'numeric'}) || '';

//   const pState = s => {
//     const order=[1,2,3,3.5,4];
//     const cur=order.indexOf(step), tgt=order.indexOf(s);
//     if (tgt<cur) return 'done';
//     if (tgt===cur) return 'active';
//     return 'idle';
//   };

//   const STEPS = [{s:1,lbl:'Time'},{s:2,lbl:'Verify'},{s:3,lbl:'Details'},{s:3.5,lbl:'Docs'},{s:4,lbl:'Confirm'}];

//   /* Account status banner */
//   const AccountBanner = () => {
//     if (!accountStatus) return null;
//     const cfg = {
//       new:      { icon:'🎉', text:'New account created — temporary password sent to your email. Please change it after login.' },
//       existing: { icon:'👋', text:'Welcome back! Continuing with your existing TrustDoctor account.' },
//     };
//     const { icon, text } = cfg[accountStatus] || {};
//     if (!icon) return null;
//     return (
//       <div style={S.authBanner(accountStatus)}>
//         <span style={{fontSize:16,flexShrink:0}}>{icon}</span>
//         <span style={{fontWeight:600,lineHeight:1.4}}>{text}</span>
//       </div>
//     );
//   };

//   return (
//     <Modal show={show} onHide={handleModalClose} centered dialogClassName="tsm-wrap">
//       <div style={{display:'flex',flexDirection:'column',maxHeight:'calc(100dvh - 12px)',overflow:'hidden',borderRadius:14}}>

//         {/* Header */}
//         <div style={S.header} className="modal-header">
//           <div style={{display:'flex',alignItems:'center',gap:10}}>
//             <div style={S.avatar}>{bookingData?.doctor?.First?.charAt(0)||'D'}{bookingData?.doctor?.Last?.charAt(0)||'R'}</div>
//             <div>
//               <p style={S.docName}>Dr. {bookingData?.doctor?.First||''} {bookingData?.doctor?.Last||''}</p>
//               <p style={S.docSpec}>{bookingData?.doctor?.Speciality||'General Physician'}</p>
//             </div>
//           </div>
//           <button type="button" className="btn-close btn-close-white" onClick={handleModalClose} style={{marginLeft:'auto'}} />
//         </div>

//         {/* Scrollable Body */}
//         <div style={S.body} className="tsm-body">

//           {/* Progress */}
//           <div style={S.progWrap}>
//             {STEPS.map(({s,lbl}) => {
//               const st = pState(s);
//               return (
//                 <div key={s} style={S.progStep}>
//                   <div style={S.circle(st)}>{st==='done'?'✓':STEPS.findIndex(x=>x.s===s)+1}</div>
//                   <div style={S.circleLabel(st)}>{lbl}</div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* ══ STEP 1: Time Slot ══ */}
//           {step===1 && (
//             <div style={S.card}>
//               <div style={S.cardTitle}>Select Time Slot</div>
//               <div style={S.highlight}>
//                 <strong style={{fontSize:12}}>Date:</strong> {bookingData?.date ? fmtDate(bookingData.date) : '—'}
//                 <div style={{marginTop:6}}>
//                   <button onClick={onBack} style={{background:'none',border:'1px solid #bfdbfe',borderRadius:6,padding:'3px 10px',fontSize:11,color:'#1d4ed8',cursor:'pointer',fontWeight:600}}>← Change Date</button>
//                 </div>
//               </div>
//               {loadingSlots ? (
//                 <div style={{textAlign:'center',padding:24}}>
//                   <Spinner animation="border" size="sm" variant="primary" />
//                   <p style={{marginTop:8,color:'#6b7280',fontSize:12}}>Loading slots…</p>
//                 </div>
//               ) : (
//                 <>
//                   {allMorning.length>0 && (
//                     <>
//                       <div style={S.sessionBar}>🌅 Morning — {allMorning.filter(x=>!x.isBooked).length} available</div>
//                       <div className="tsm-slots-grid" style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(82px,1fr))',gap:6,marginBottom:10}}>
//                         {allMorning.map((sl,i)=>(
//                           <button key={i} style={S.slot(selectedSlot===sl.value,sl.isBooked)} onClick={()=>!sl.isBooked&&setSelectedSlot(sl.value)} disabled={sl.isBooked}>
//                             {sl.display}
//                             {sl.isBooked && <div style={{fontSize:9,color:'#9ca3af',marginTop:2}}>Booked</div>}
//                           </button>
//                         ))}
//                       </div>
//                     </>
//                   )}
//                   {showBreak && allMorning.length>0 && allEvening.length>0 && <div style={S.breakBar}>⏸ Break Time</div>}
//                   {allEvening.length>0 && (
//                     <>
//                       <div style={S.sessionBar}>🌆 Evening — {allEvening.filter(x=>!x.isBooked).length} available</div>
//                       <div className="tsm-slots-grid" style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(82px,1fr))',gap:6,marginBottom:10}}>
//                         {allEvening.map((sl,i)=>(
//                           <button key={i} style={S.slot(selectedSlot===sl.value,sl.isBooked)} onClick={()=>!sl.isBooked&&setSelectedSlot(sl.value)} disabled={sl.isBooked}>
//                             {sl.display}
//                             {sl.isBooked && <div style={{fontSize:9,color:'#9ca3af',marginTop:2}}>Booked</div>}
//                           </button>
//                         ))}
//                       </div>
//                     </>
//                   )}
//                   {!allMorning.length && !allEvening.length && (
//                     <div style={{background:'#fef9c3',border:'1px solid #fde68a',borderRadius:8,padding:'10px 12px',fontSize:12,color:'#854d0e'}}>
//                       <strong>No slots available.</strong> Please try another date.
//                     </div>
//                   )}
//                   {(allMorning.length>0||allEvening.length>0) && (
//                     <div style={{textAlign:'center',marginTop:14}}>
//                       <Button style={S.btnPrimary} onClick={()=>{if(!selectedSlot){toast.error('Select a slot');return;}setStep(2);}} disabled={!selectedSlot}>
//                         Continue →
//                       </Button>
//                     </div>
//                   )}
//                 </>
//               )}
//             </div>
//           )}

//           {/* ══ STEP 2: Contact + OTP ══ */}
//           {step===2 && (
//             <div style={S.card}>
//               <div style={S.cardTitle}>Verify Contact</div>

//               {!otpSent && (
//                 <div style={{background:'#f0f9ff',border:'1px solid #bae6fd',borderRadius:8,padding:'8px 12px',marginBottom:12,fontSize:11,color:'#0369a1',lineHeight:1.5}}>
//                   💡 <strong>Already registered?</strong> Enter your registered email — we'll recognise you automatically after OTP verification. No separate login needed!
//                 </div>
//               )}

//               {!otpSent ? (
//                 <>
//                   <div style={S.highlight}><strong style={{fontSize:12}}>Slot:</strong> {fmtDate(bookingData?.date)}, {selectedSlot}</div>
//                   {[
//                     {label:'Patient Name *', val:patientName, set:setPatientName, err:nameError, type:'text', ph:'Full name'},
//                     {label:'Mobile Number *', val:phoneNumber, set:setPhoneNumber, err:phoneError, type:'tel', ph:'10-digit mobile', maxLen:10},
//                     {label:'Email Address *', val:email, set:setEmail, err:emailError, type:'email', ph:'your@email.com'},
//                   ].map(({label,val,set,err,type,ph,maxLen})=>(
//                     <div key={label} style={{marginBottom:12}}>
//                       <label style={S.label}>{label}</label>
//                       <input type={type} style={S.input} placeholder={ph} value={val} onChange={e=>set(e.target.value)} maxLength={maxLen} />
//                       {err && <div style={S.err}>{err}</div>}
//                     </div>
//                   ))}
//                   <Button style={S.btnPrimary} onClick={sendOTP} disabled={loading||!patientName||!phoneNumber||!email}>
//                     {loading ? <><Spinner animation="border" size="sm" style={{marginRight:6}}/>Sending…</> : '📩 Send OTP'}
//                   </Button>
//                 </>
//               ) : (
//                 <div style={{textAlign:'center',padding:'10px 0'}}>
//                   <p style={{fontSize:13,color:'#374151',marginBottom:4,fontWeight:600}}>Enter 6-digit OTP</p>
//                   <p style={{fontSize:11,color:'#6b7280',marginBottom:16}}>Sent to <strong>{email}</strong></p>
//                   <div className="tsm-otp-inputs" style={{display:'flex',justifyContent:'center',gap:10,marginBottom:16}}>
//                     {otp.map((d,i)=>(
//                       <input key={i} id={`tsm-otp-${i}`} type="text" maxLength={1}
//                         style={{...S.input,width:44,height:44,textAlign:'center',fontSize:20,fontWeight:700,padding:0,borderRadius:8}}
//                         value={d} onChange={e=>handleOtpChange(i,e.target.value)} onKeyDown={e=>handleOtpKey(i,e)} autoFocus={i===0} />
//                     ))}
//                   </div>
//                   {loading ? (
//                     <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:8,color:'#4285f4',fontSize:13,fontWeight:600}}>
//                       <Spinner animation="border" size="sm" /> Setting up your account…
//                     </div>
//                   ) : (
//                     <Button style={S.btnPrimary} onClick={verifyOTP} disabled={otp.join('').length!==6}>
//                       Verify & Continue
//                     </Button>
//                   )}
//                   <div style={{marginTop:12}}>
//                     <button onClick={()=>setOtpSent(false)} style={{background:'none',border:'none',color:'#4285f4',fontSize:12,cursor:'pointer',textDecoration:'underline'}}>← Change Email/Phone</button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* ══ STEP 3: Patient Details ══ */}
//           {step===3 && (
//             <div style={S.card}>
//               <div style={S.cardTitle}>Patient Details</div>
//               <AccountBanner />
//               <div style={S.highlight}><strong style={{fontSize:12}}>Slot:</strong> {fmtDate(bookingData?.date)}, {selectedSlot}</div>
//               <div style={{marginBottom:12}}>
//                 <label style={S.label}>Patient Age *</label>
//                 <input type="number" style={S.input} placeholder="Age in years" value={patientAge} onChange={e=>setPatientAge(e.target.value)} min="0" max="150" />
//                 {ageError && <div style={S.err}>{ageError}</div>}
//               </div>
//               <div style={S.health}>
//                 <div style={{fontSize:13,fontWeight:700,color:'#c2410c',marginBottom:10}}>🏥 Health Information</div>
//                 {[
//                   {lbl:'Current Issues / Reason for Visit',val:healthIssues,set:setHealthIssues,max:500,ph:'Fever, chest pain…'},
//                   {lbl:'Medical History',val:medHistory,set:setMedHistory,max:500,ph:'Diabetes, hypertension…'},
//                   {lbl:'Current Medications',val:curMeds,set:setCurMeds,max:300,ph:'Metformin 500mg…'},
//                 ].map(({lbl,val,set,max,ph})=>(
//                   <div key={lbl} style={{marginBottom:10}}>
//                     <label style={S.label}>{lbl}</label>
//                     <textarea style={S.textarea} placeholder={ph} value={val} onChange={e=>set(e.target.value)} maxLength={max} />
//                     <div style={{fontSize:10,color:'#9ca3af',textAlign:'right'}}>{val.length}/{max}</div>
//                   </div>
//                 ))}
//               </div>
//               <div style={{fontSize:11,color:'#6b7280',marginTop:10,padding:'8px 10px',background:'#f8fafc',borderRadius:7}}>
//                 ✅ Verified: 📱 {phoneNumber} · 📧 {email}
//               </div>
//               <div style={{marginTop:14}}>
//                 <Button style={S.btnPrimary} onClick={confirmBooking} disabled={!patientAge}>Continue →</Button>
//               </div>
//             </div>
//           )}

//           {/* ══ STEP 3.5: Share Documents ══ */}
//           {step===3.5 && (
//             <div style={S.card}>
//               <div style={S.cardTitle}>Share Medical Documents</div>
//               <div style={S.shareBox}>
//                 <div style={S.shareTitle}>📁 Share documents with doctor?</div>
//                 <div style={S.shareSub}>Optionally share uploaded reports so the doctor can review them before your appointment.</div>
//                 {wantsToShare===null && (
//                   <div className="tsm-share-btns" style={{display:'flex',gap:10}}>
//                     <button style={{flex:1,padding:'10px',borderRadius:8,border:'1.5px solid #4285f4',background:'#4285f4',color:'#fff',fontWeight:700,fontSize:13,cursor:'pointer'}} onClick={()=>setWantsToShare(true)}>✅ Yes, share</button>
//                     <button style={{flex:1,padding:'10px',borderRadius:8,border:'1.5px solid #e2e8f0',background:'#fff',color:'#6b7280',fontWeight:600,fontSize:13,cursor:'pointer'}} onClick={()=>{setWantsToShare(false);setSelectedDocIds([]);}}>❌ Skip</button>
//                   </div>
//                 )}
//                 {wantsToShare===false && (
//                   <div style={{display:'flex',alignItems:'center',gap:10}}>
//                     <span style={{fontSize:12,color:'#6b7280'}}>No documents will be shared.</span>
//                     <button onClick={()=>setWantsToShare(null)} style={{background:'none',border:'none',color:'#4285f4',fontSize:12,cursor:'pointer',textDecoration:'underline'}}>Change</button>
//                   </div>
//                 )}
//               </div>
//               {wantsToShare===true && (
//                 <div>
//                   <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
//                     <span style={{fontSize:12,fontWeight:700,color:'#1e293b'}}>Select documents:</span>
//                     <button onClick={()=>setWantsToShare(null)} style={{background:'none',border:'none',color:'#4285f4',fontSize:11,cursor:'pointer',textDecoration:'underline'}}>Cancel</button>
//                   </div>
//                   {loadingDocs ? (
//                     <div style={{textAlign:'center',padding:20}}><Spinner animation="border" size="sm" /> <span style={{fontSize:12}}>Loading…</span></div>
//                   ) : patientDocs.length===0 ? (
//                     <div style={{textAlign:'center',padding:20,background:'#f8fafc',borderRadius:8,color:'#9ca3af',fontSize:12,border:'1px dashed #e2e8f0'}}>
//                       <div style={{fontSize:28,marginBottom:6}}>📂</div>No documents uploaded yet.
//                     </div>
//                   ) : (
//                     <>
//                       <div style={{fontSize:11,color:'#6b7280',marginBottom:8}}>{selectedDocIds.length}/{patientDocs.length} selected</div>
//                       {patientDocs.map(doc=>{
//                         const sel=selectedDocIds.includes(doc.reportId);
//                         return (
//                           <div key={doc.reportId} style={S.docCard(sel)} onClick={()=>toggleDoc(doc.reportId)}>
//                             <div style={{display:'flex',alignItems:'center',gap:10}}>
//                               <span style={{fontSize:22}}>{fileIcon(doc.fileType,doc.fileName)}</span>
//                               <div>
//                                 <div style={{fontSize:12,fontWeight:600,color:'#1e293b'}}>{doc.description||doc.fileName||'Document'}</div>
//                                 <div style={{fontSize:10,color:'#9ca3af'}}>
//                                   {doc.fileName} {doc.fileSizeMB&&`· ${doc.fileSizeMB}MB`} {doc.uploadedAt&&`· ${new Date(doc.uploadedAt).toLocaleDateString()}`}
//                                 </div>
//                               </div>
//                             </div>
//                             <div style={S.docCheck(sel)}>{sel?'✓':''}</div>
//                           </div>
//                         );
//                       })}
//                       {selectedDocIds.length>0 && (
//                         <div style={{marginTop:8,padding:'8px 10px',background:'#f0fdf4',borderRadius:7,fontSize:11,color:'#15803d',fontWeight:600}}>
//                           ✅ {selectedDocIds.length} doc{selectedDocIds.length>1?'s':''} will be shared
//                         </div>
//                       )}
//                     </>
//                   )}
//                 </div>
//               )}
//               <div style={{marginTop:14}}>
//                 <Button style={S.btnPrimary} onClick={()=>setStep(4)} disabled={wantsToShare===null}>
//                   {wantsToShare&&selectedDocIds.length>0 ? `Share ${selectedDocIds.length} & Continue →` : 'Continue to Summary →'}
//                 </Button>
//               </div>
//             </div>
//           )}

//           {/* ══ STEP 4: Summary ══ */}
//           {step===4 && (
//             <div style={S.card}>
//               <div style={S.cardTitle}>Appointment Summary</div>
//               <AccountBanner />
//               <div style={S.sumCard}>
//                 {[
//                   {icon:'👨‍⚕️',title:'Doctor',rows:[
//                     ['Doctor',`Dr. ${bookingData?.doctor?.First||''} ${bookingData?.doctor?.Last||''}`],
//                     ['Speciality',bookingData?.doctor?.Speciality||'General Physician'],
//                     ['Clinic',bookingData?.doctor?.ClinicName||"Doctor's Clinic"],
//                   ]},
//                   {icon:'📅',title:'Appointment',rows:[['Date',fmtDate(bookingData?.date)],['Time',selectedSlot]]},
//                   {icon:'👤',title:'Patient',rows:[['Name',patientName],['Age',`${patientAge} yrs`],['Mobile',phoneNumber],['Email',email]]},
//                 ].map(({icon,title,rows})=>(
//                   <div key={title} style={S.sumSec}>
//                     <div style={S.sumTitle}>{icon} {title}</div>
//                     {rows.map(([l,v])=>(
//                       <div key={l} style={S.sumRow}><span style={S.sumLbl}>{l}</span><span style={S.sumVal}>{v}</span></div>
//                     ))}
//                   </div>
//                 ))}
//                 <div style={{...S.sumSec,borderBottom:'none',background:wantsToShare&&selectedDocIds.length?'#f0fdf4':'#fafafa'}}>
//                   <div style={S.sumTitle}>📁 Documents</div>
//                   {wantsToShare&&selectedDocIds.length>0 ? (
//                     <>
//                       <div style={{fontSize:11,color:'#15803d',fontWeight:600,marginBottom:6}}>✅ Sharing {selectedDocIds.length} doc{selectedDocIds.length>1?'s':''}</div>
//                       {patientDocs.filter(d=>selectedDocIds.includes(d.reportId)).map(d=>(
//                         <div key={d.reportId} style={{display:'flex',alignItems:'center',gap:6,fontSize:11,padding:'4px 0',borderBottom:'1px solid #f0f0f0'}}>
//                           {fileIcon(d.fileType,d.fileName)} <span style={{fontWeight:600}}>{d.description||d.fileName}</span>
//                           <span style={{background:'#dcfce7',color:'#16a34a',fontSize:10,fontWeight:700,padding:'1px 6px',borderRadius:10,border:'1px solid #bbf7d0'}}>Shared</span>
//                         </div>
//                       ))}
//                     </>
//                   ) : <div style={{fontSize:11,color:'#9ca3af'}}>No documents shared</div>}
//                 </div>
//                 {(healthIssues||medHistory||curMeds) && (
//                   <div style={{...S.sumSec,borderBottom:'none',background:'#fff7ed'}}>
//                     <div style={S.sumTitle}>🏥 Health Info</div>
//                     {[['Issues',healthIssues],['History',medHistory],['Medications',curMeds]].filter(([,v])=>v).map(([l,v])=>(
//                       <div key={l} style={{marginBottom:8}}>
//                         <div style={{fontSize:11,color:'#6b7280',fontWeight:600,marginBottom:3}}>{l}:</div>
//                         <div style={{fontSize:11,color:'#374151',background:'#fff',padding:'6px 8px',borderRadius:6}}>{v}</div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//               <div style={{marginTop:14}}>
//                 <Button style={S.btnSuccess} onClick={finalizeBooking} disabled={loading}>
//                   {loading ? <><Spinner animation="border" size="sm" style={{marginRight:6}}/>Booking…</> : '✅ Confirm & Book Appointment'}
//                 </Button>
//               </div>
//             </div>
//           )}

//         </div>{/* end scrollable body */}

//         {/* Footer */}
//         <div style={S.footer}>
//           <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
//             <div>
//               {step>1 && step<4 && (
//                 <button style={{background:'none',border:'1px solid #e2e8f0',borderRadius:7,padding:'6px 14px',fontSize:12,fontWeight:600,color:'#6b7280',cursor:'pointer'}}
//                   onClick={()=>{
//                     if (step===2&&otpSent) { setOtpSent(false); return; }
//                     if (step===3.5) { setStep(3); return; }
//                     setStep(s=>s-1);
//                   }}>← Back</button>
//               )}
//             </div>
//             <button style={{background:'none',border:'1px solid #fca5a5',borderRadius:7,padding:'6px 14px',fontSize:12,fontWeight:600,color:'#ef4444',cursor:'pointer'}}
//               onClick={handleModalClose}>Cancel</button>
//           </div>
//         </div>

//       </div>
//     </Modal>
//   );
// };

// export default TimeSlotModal;


import React, { useState, useEffect } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { getDatabase, ref, get, set, update, onValue, query, orderByChild, equalTo } from "firebase/database";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, updateProfile } from "firebase/auth";
import { app } from "../../../Doctor/Firebase/firebase.config";
import { useAuth } from "../../AuthContext";
import emailjs from "@emailjs/browser";

const database = getDatabase(app);
const auth = getAuth(app);

const EMAILJS_SERVICE_ID               = 'service_cab38e6';
const EMAILJS_OTP_TEMPLATE_ID          = 'template_h08g4fm';
const EMAILJS_CONFIRMATION_TEMPLATE_ID = 'template_c2m3r4j';
const EMAILJS_PUBLIC_KEY               = 'rnBYIQUEQDDpqOcl1';

/* ── Inject scrollbar + responsive CSS once ── */
const MODAL_CSS = `
  .tsm-body::-webkit-scrollbar { width: 4px; }
  .tsm-body::-webkit-scrollbar-track { background: #eef2ff; border-radius: 10px; }
  .tsm-body::-webkit-scrollbar-thumb { background: #4285f4; border-radius: 10px; }
  .tsm-body::-webkit-scrollbar-thumb:hover { background: #2563eb; }
  .tsm-wrap .modal-dialog { margin: 6px auto !important; max-width: 500px !important; }
  .tsm-wrap .modal-content {
    border-radius: 14px !important; border: none !important; overflow: hidden !important;
    max-height: calc(100dvh - 12px) !important; display: flex !important;
    flex-direction: column !important; box-shadow: 0 10px 40px rgba(0,0,0,0.15) !important;
  }
  @media (max-width: 576px) {
    .tsm-wrap .modal-dialog { margin: 4px !important; max-width: calc(100vw - 8px) !important; }
    .tsm-wrap .modal-content { max-height: calc(100dvh - 8px) !important; border-radius: 12px !important; }
    .tsm-slots-grid { grid-template-columns: repeat(auto-fill, minmax(75px, 1fr)) !important; gap: 6px !important; }
    .tsm-otp-inputs { gap: 8px !important; }
    .tsm-share-btns { flex-direction: column !important; }
    .tsm-body { padding: 10px !important; }
  }
`;
if (typeof document !== 'undefined' && !document.getElementById('tsm-css')) {
  const s = document.createElement('style'); s.id = 'tsm-css'; s.textContent = MODAL_CSS;
  document.head.appendChild(s);
}

/* ── Style tokens ── */
const S = {
  header: { background: 'linear-gradient(135deg,#4285f4 0%,#34a853 100%)', padding: '12px 16px', borderBottom: 'none', flexShrink: 0 },
  avatar: { width: 40, height: 40, borderRadius: '50%', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, fontWeight: 700, color: '#4285f4', flexShrink: 0 },
  docName: { fontSize: 15, fontWeight: 600, margin: 0, color: '#fff' },
  docSpec: { fontSize: 12, opacity: .88, margin: 0, color: '#fff' },
  body: { padding: '12px 14px', background: '#f4f6fb', overflowY: 'auto', overflowX: 'hidden', flex: '1 1 auto', scrollbarWidth: 'thin', scrollbarColor: '#4285f4 #eef2ff' },
  progWrap: { display: 'flex', justifyContent: 'space-between', background: '#fff', padding: '10px 12px', borderRadius: 10, marginBottom: 12, boxShadow: '0 1px 6px rgba(0,0,0,.06)' },
  progStep: { flex: 1, textAlign: 'center' },
  circle: (st) => ({
    width: 28, height: 28, borderRadius: '50%', margin: '0 auto 3px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontWeight: 700, fontSize: 12, transition: 'all .25s',
    background: st === 'active' ? '#4285f4' : st === 'done' ? '#34a853' : '#e5e7eb',
    color: st !== 'idle' ? '#fff' : '#9ca3af',
    boxShadow: st === 'active' ? '0 2px 8px rgba(66,133,244,.35)' : 'none',
  }),
  circleLabel: (st) => ({ fontSize: 9, fontWeight: st === 'active' ? 700 : 500, color: st === 'active' ? '#4285f4' : st === 'done' ? '#34a853' : '#9ca3af' }),
  card: { background: '#fff', borderRadius: 10, padding: '14px', boxShadow: '0 1px 8px rgba(0,0,0,.06)' },
  cardTitle: { fontSize: 14, fontWeight: 700, color: '#1e293b', borderBottom: '2px solid #4285f4', paddingBottom: 8, marginBottom: 12 },
  sessionBar: { background: '#f1f5f9', padding: '7px 10px', borderRadius: 7, fontWeight: 600, fontSize: 12, color: '#334155', marginBottom: 8 },
  breakBar: { background: '#fef9c3', padding: '7px 10px', borderRadius: 7, fontWeight: 600, fontSize: 12, color: '#854d0e', textAlign: 'center', margin: '8px 0', border: '1px solid #fde68a' },
  slot: (sel, booked) => ({
    padding: '7px 4px', borderRadius: 7, fontSize: 11, fontWeight: 600, textAlign: 'center',
    minHeight: 38, cursor: booked ? 'not-allowed' : 'pointer', transition: 'all .18s', lineHeight: 1.3,
    border: sel ? '2px solid #4285f4' : '1.5px solid #e2e8f0',
    background: booked ? '#f9fafb' : sel ? '#4285f4' : '#fff',
    color: booked ? '#d1d5db' : sel ? '#fff' : '#374151',
    textDecoration: booked ? 'line-through' : 'none',
  }),
  label: { fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 },
  input: { width: '100%', padding: '8px 10px', fontSize: 13, border: '1.5px solid #e2e8f0', borderRadius: 7, outline: 'none', transition: 'border .2s', boxSizing: 'border-box' },
  textarea: { width: '100%', padding: '8px 10px', fontSize: 12, border: '1.5px solid #e2e8f0', borderRadius: 7, minHeight: 72, fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box' },
  err: { color: '#ef4444', fontSize: 11, marginTop: 3 },
  highlight: { background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, padding: '8px 10px', fontSize: 12, marginBottom: 10 },
  health: { background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 8, padding: '10px 12px', marginTop: 8 },
  authBanner: (type) => ({
    display: 'flex', alignItems: 'flex-start', gap: 8, padding: '8px 12px',
    borderRadius: 8, marginBottom: 12, fontSize: 12,
    background: type === 'new' ? '#f0fdf4' : type === 'existing' ? '#eff6ff' : '#fef9c3',
    border: `1px solid ${type === 'new' ? '#bbf7d0' : type === 'existing' ? '#bfdbfe' : '#fde68a'}`,
    color: type === 'new' ? '#15803d' : type === 'existing' ? '#1d4ed8' : '#854d0e',
  }),
  sumCard: { borderRadius: 10, overflow: 'hidden', border: '1px solid #e2e8f0' },
  sumSec: { padding: '10px 14px', borderBottom: '1px solid #f1f5f9' },
  sumTitle: { fontSize: 13, fontWeight: 700, color: '#1e293b', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 },
  sumRow: { display: 'flex', justifyContent: 'space-between', padding: '5px 0', borderBottom: '1px solid #f8fafc' },
  sumLbl: { fontSize: 12, color: '#6b7280', fontWeight: 500 },
  sumVal: { fontSize: 12, color: '#1e293b', fontWeight: 600, textAlign: 'right', maxWidth: '55%', wordBreak: 'break-word' },
  shareBox: { border: '1.5px solid #bfdbfe', borderRadius: 10, padding: '14px', marginBottom: 12, background: 'linear-gradient(135deg,#eff6ff,#f0fdf9)' },
  shareTitle: { fontSize: 14, fontWeight: 700, color: '#1e3a8a', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 8 },
  shareSub: { fontSize: 12, color: '#64748b', marginBottom: 12, lineHeight: 1.5 },
  docCard: (sel) => ({ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', borderRadius: 8, marginBottom: 8, border: sel ? '1.5px solid #4285f4' : '1.5px solid #e2e8f0', background: sel ? '#eff6ff' : '#fff', cursor: 'pointer', transition: 'all .18s' }),
  docCheck: (sel) => ({ width: 20, height: 20, borderRadius: '50%', flexShrink: 0, border: '2px solid #4285f4', display: 'flex', alignItems: 'center', justifyContent: 'center', background: sel ? '#4285f4' : '#fff', color: '#fff', fontSize: 11 }),
  btnPrimary: { background: '#4285f4', border: 'none', borderRadius: 8, padding: '9px 20px', fontSize: 13, fontWeight: 600, color: '#fff' },
  btnSuccess: { background: '#34a853', border: 'none', borderRadius: 8, padding: '9px 20px', fontSize: 13, fontWeight: 600, color: '#fff', width: '100%' },
  footer: { background: '#fff', padding: '10px 16px', borderTop: '1px solid #e2e8f0', flexShrink: 0 },
};

/* ── Helpers ── */
const generateTimeSlots = (startTime, endTime) => {
  const slots = [];
  const parse = (t) => { if (!t) return null; const [h,m]=t.split(':').map(Number); const d=new Date(); d.setHours(h,m||0,0,0); return d; };
  const start = parse(startTime), end = parse(endTime);
  if (!start || !end || end <= start) return slots;
  const cur = new Date(start);
  while (cur < end) {
    const h=cur.getHours(), m=cur.getMinutes(), ap=h>=12?'PM':'AM';
    const dh=h%12||12, dm=m<10?'0'+m:m;
    slots.push({ display:`${dh}:${dm} ${ap}`, value:`${dh}:${dm} ${ap}`, time24:`${String(h).padStart(2,'0')}:${dm}` });
    cur.setTime(cur.getTime()+15*60000);
  }
  return slots;
};

const needsBreak = (me, es) => {
  if (!me||!es) return false;
  const p=(t)=>{const[h,m]=t.split(':').map(Number);const d=new Date();d.setHours(h,m||0,0,0);return d;};
  return (p(es)-p(me))/(1000*60)>=30;
};

const fileIcon = (ft, fn) => {
  const t=ft||'', n=(fn||'').toLowerCase();
  if (t.includes('pdf')||n.endsWith('.pdf')) return '📋';
  if (t.includes('image')||n.match(/\.(jpg|jpeg|png|webp)$/)) return '🖼️';
  if (n.match(/\.(doc|docx)$/)) return '📝';
  return '📄';
};

/* ────────────────────────────────────────────────────────────
   resolveUserForBooking
   ─────────────────────────────────────────────────────────────
   Logic:
   1. Already logged-in → use their uid (no action needed)
   2. Email found in DB → existing user → silently sign in → auto-login
   3. Email not found anywhere → NEW USER → just generate a stable guest ID
      from their email (no Firebase Auth account, no login, no password email)
      They book as a guest; account can be created later if they choose to register.
──────────────────────────────────────────────────────────── */
const resolveUserForBooking = async (emailAddr, phonNum, fullName) => {
  const tempPwd = `TD@${phonNum}#Trusty`;

  // 1. Already signed in — use their session
  if (auth.currentUser) {
    return { userId: auth.currentUser.uid, isNewUser: false, isGuest: false };
  }

  // 2. Check DB for existing account with this email
  try {
    const snap = await get(
      query(ref(database, 'users'), orderByChild('email'), equalTo(emailAddr))
    );
    if (snap.exists()) {
      const uid = Object.keys(snap.val())[0];
      // Silently sign them in so their session is live
      try {
        const cred = await signInWithEmailAndPassword(auth, emailAddr, tempPwd);
        return { userId: cred.user.uid, isNewUser: false, isGuest: false };
      } catch (_) {
        // Wrong password / different auth method — uid from DB is still valid for booking
        return { userId: uid, isNewUser: false, isGuest: false };
      }
    }
  } catch (e) {
    console.warn('DB email lookup:', e);
  }

  // 3. Try Firebase Auth sign-in (account in Auth but DB record missing)
  try {
    const cred = await signInWithEmailAndPassword(auth, emailAddr, tempPwd);
    const uid = cred.user.uid;
    // Rebuild missing DB record
    await set(ref(database, `users/${uid}`), {
      userId: uid, name: fullName, email: emailAddr, mobile: phonNum,
      accountType: 'patient', createdAt: new Date().toISOString(),
    });
    return { userId: uid, isNewUser: false, isGuest: false };
  } catch (e) {
    // auth/user-not-found or auth/invalid-credential → truly new user, fall through
    if (e.code !== 'auth/user-not-found' &&
        e.code !== 'auth/invalid-credential' &&
        e.code !== 'auth/wrong-password') {
      throw e;
    }
  }

  // ── NEW USER ──
  // No account found anywhere. Do NOT create Firebase Auth or send password emails.
  // Generate a stable guest ID from their email so we can write to DB.
  // They can register a proper account later from their profile.
  const guestId = `guest_${btoa(emailAddr).replace(/[^a-zA-Z0-9]/g, '').substring(0, 20)}_${Date.now()}`;
  return { userId: guestId, isNewUser: true, isGuest: true };
};

/* ── Component ── */
const TimeSlotModal = ({ show, handleClose, bookingData, onBack, onBookingComplete }) => {
  const { user, setUser } = useAuth();

  const [step, setStep]                   = useState(1);
  const [loading, setLoading]             = useState(false);
  const [loadingSlots, setLoadingSlots]   = useState(false);
  const [otpSent, setOtpSent]             = useState(false);
  const [generatedOTP, setGeneratedOTP]   = useState('');
  const [resolvedUserId, setResolvedUserId] = useState(null);
  const [accountStatus, setAccountStatus]   = useState(null); // 'new' | 'existing'

  const [selectedSlot, setSelectedSlot] = useState('');
  const [allMorning, setAllMorning]     = useState([]);
  const [allEvening, setAllEvening]     = useState([]);
  const [bookedSlots, setBookedSlots]   = useState([]);
  const [showBreak, setShowBreak]       = useState(false);

  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail]             = useState('');
  const [otp, setOtp]                 = useState(['','','','','','']);
  const [phoneError, setPhoneError]   = useState('');
  const [emailError, setEmailError]   = useState('');
  const [nameError, setNameError]     = useState('');

  const [patientName, setPatientName] = useState('');
  const [patientAge, setPatientAge]   = useState('');
  const [ageError, setAgeError]       = useState('');
  const [healthIssues, setHealthIssues] = useState('');
  const [medHistory, setMedHistory]     = useState('');
  const [curMeds, setCurMeds]           = useState('');

  const [patientDocs, setPatientDocs]       = useState([]);
  const [loadingDocs, setLoadingDocs]       = useState(false);
  const [wantsToShare, setWantsToShare]     = useState(null);
  const [selectedDocIds, setSelectedDocIds] = useState([]);

  /* fetch docs — only for existing (non-guest) users */
  useEffect(() => {
    if (!show) return;
    const uid = resolvedUserId || user?.userId || user?.uid;
    // guests won't have uploaded docs — skip
    if (!uid || uid.startsWith('guest_')) return;
    setLoadingDocs(true);
    const unsub = onValue(ref(database, `users/${uid}/reports`), snap => {
      const data = snap.val();
      setPatientDocs(data
        ? Object.entries(data).map(([k,v])=>({reportId:k,...v})).sort((a,b)=>new Date(b.uploadedAt)-new Date(a.uploadedAt))
        : []);
      setLoadingDocs(false);
    });
    return () => unsub();
  }, [show, user, resolvedUserId]);

  /* fetch booked slots */
  useEffect(() => {
    if (!show || !bookingData?.doctor) return;
    (async () => {
      try {
        setLoadingSlots(true);
        const snap = await get(ref(database, `doctor/${bookingData.doctor.uid}/appointments`));
        setBookedSlots(snap.exists() ? Object.values(snap.val()) : []);
      } catch { toast.error('Failed to load slots'); }
      finally { setLoadingSlots(false); }
    })();
  }, [show, bookingData]);

  /* build slots */
  useEffect(() => {
    if (!bookingData?.schedule) { setAllMorning([]); setAllEvening([]); return; }
    const { morningStartTime:ms, morningEndTime:me, eveningStartTime:es, eveningEndTime:ee } = bookingData.schedule;
    const morning = ms && me ? generateTimeSlots(ms, me) : [];
    const evening = es && ee ? generateTimeSlots(es, ee) : [];
    setShowBreak(needsBreak(me, es));
    const fmt = bookingData.date.toLocaleDateString('en-US',{year:'numeric',month:'2-digit',day:'2-digit'});
    const mark = slots => slots.map(sl => ({
      ...sl,
      isBooked: bookedSlots.some(b => {
        if (!b.date||!b.timeSlot) return false;
        const bd = new Date(b.date).toLocaleDateString('en-US',{year:'numeric',month:'2-digit',day:'2-digit'});
        return bd === fmt && b.timeSlot === sl.value;
      }),
    }));
    setAllMorning(mark(morning));
    setAllEvening(mark(evening));
  }, [bookingData, bookedSlots]);

  const toggleDoc = id => setSelectedDocIds(p => p.includes(id) ? p.filter(x=>x!==id) : [...p,id]);

  /* ── Send OTP ── */
  const sendOTP = async () => {
    setPhoneError(''); setEmailError(''); setNameError('');
    if (!patientName.trim()) { setNameError('Name required'); toast.error('Enter patient name'); return; }
    if (!phoneNumber.trim()) { setPhoneError('Phone required'); return; }
    if (!/^[6-9]\d{9}$/.test(phoneNumber)) { setPhoneError('Invalid 10-digit number'); return; }
    if (!email.trim()) { setEmailError('Email required'); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setEmailError('Invalid email'); return; }
    setLoading(true);
    const code = Math.floor(100000 + Math.random()*900000).toString();
    setGeneratedOTP(code);
    try {
      const expiry = new Date(); expiry.setMinutes(expiry.getMinutes()+15);
      const expiryStr = expiry.toLocaleTimeString('en-US',{hour:'2-digit',minute:'2-digit',hour12:true});
      await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_OTP_TEMPLATE_ID, {
        to_email: email,
        to_name: patientName || 'Patient',
        passcode: code,
        otp: code,
        OTP: code,
        time: expiryStr,
        expiry_time: expiryStr,
        doctor_name: `Dr. ${bookingData?.doctor?.First||''} ${bookingData?.doctor?.Last||''}`,
        appointment_date: bookingData?.date?.toLocaleDateString('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric'}) || '',
        appointment_time: selectedSlot,
      }, EMAILJS_PUBLIC_KEY);
      setOtpSent(true);
      toast.success(`OTP sent to ${email}`);
    } catch {
      toast.error('OTP send failed');
      toast.info(`Dev OTP: ${code}`, { autoClose: false });
    } finally { setLoading(false); }
  };

  /* ────────────────────────────────────────────────────────────
     verifyOTP
     ─────────────────────────────────────────────────────────────
     After correct OTP:
     - NEW USER  → proceed directly to step 3 (no login, no password email)
     - EXISTING  → silently auto-login → proceed to step 3
  ──────────────────────────────────────────────────────────── */
  const verifyOTP = async () => {
    if (otp.join('') !== generatedOTP) { toast.error('Wrong OTP. Try again.'); return; }
    setLoading(true);

    try {
      // Already logged in — use existing session
      const existingUid = user?.userId || user?.uid || auth.currentUser?.uid;
      if (existingUid) {
        setResolvedUserId(existingUid);
        setAccountStatus('existing');
        toast.success('✅ OTP verified! Continuing with your account.');
        setStep(3);
        setLoading(false);
        return;
      }

      const { userId, isNewUser, isGuest } = await resolveUserForBooking(email, phoneNumber, patientName);

      setResolvedUserId(userId);
      setAccountStatus(isNewUser ? 'new' : 'existing');

      if (isNewUser) {
        // ✅ NEW USER: just verify OTP and continue — NO login required, NO password email
        toast.success('✅ OTP verified! You can now book your appointment.');
        // DO NOT send password email, DO NOT create Firebase Auth account here
      } else {
        // ✅ EXISTING USER: silently logged in
        toast.success('👋 Welcome back! You have been automatically logged in.');
        // Update AuthContext so rest of app reflects logged-in state
        if (typeof setUser === 'function') {
          setUser({ userId, uid: userId, email, name: patientName, mobile: phoneNumber });
        }
      }

      setStep(3);
    } catch (err) {
      console.error('OTP verify error:', err);
      toast.error(err.message || 'Verification failed. Please try again.');
      // Stay on step 2 so user can retry
    } finally {
      setLoading(false);
    }
  };

  const handleOtpChange = (i, v) => {
    if (!/^\d*$/.test(v)) return;
    const n=[...otp]; n[i]=v; setOtp(n);
    if (v && i<5) document.getElementById(`tsm-otp-${i+1}`)?.focus();
  };
  const handleOtpKey = (i, e) => {
    if (e.key==='Backspace' && !otp[i] && i>0) document.getElementById(`tsm-otp-${i-1}`)?.focus();
  };

  const confirmBooking = () => {
    setNameError(''); setAgeError('');
    if (!patientName.trim()) { setNameError('Name required'); return; }
    if (!patientAge.trim()) { setAgeError('Age required'); return; }
    if (isNaN(patientAge)||+patientAge<0||+patientAge>150) { setAgeError('Invalid age'); return; }
    setStep(3.5);
  };

  /* ── Finalize booking ── */
  const finalizeBooking = async () => {
    const activeUserId = resolvedUserId || user?.userId || user?.uid;

    if (!activeUserId) {
      toast.error('Session expired. Please verify your OTP again.');
      setStep(2);
      setOtpSent(false);
      return;
    }

    if (!selectedSlot) { toast.error('No slot selected'); return; }
    setLoading(true);

    try {
      const aptId = `apt_${Date.now()}_${Math.random().toString(36).substr(2,9)}`;
      const aptDate = bookingData.date.toLocaleDateString('en-US',{year:'numeric',month:'2-digit',day:'2-digit'});
      const isGuestBooking = activeUserId.startsWith('guest_');

      const sharedDocs = wantsToShare && selectedDocIds.length && !isGuestBooking
        ? patientDocs.filter(d=>selectedDocIds.includes(d.reportId)).map(d=>({
            reportId:d.reportId, fileName:d.fileName||'Doc', description:d.description||'',
            fileType:d.fileType||'', fileSizeMB:d.fileSizeMB||'', uploadedAt:d.uploadedAt||'', fileData:d.fileData||'',
          }))
        : [];

      const apt = {
        appointmentId: aptId,
        id: aptId,
        patientID: activeUserId,
        patientName: patientName.trim(),
        patientAge: patientAge.trim(),
        patientPhone: phoneNumber.trim(),
        patientEmail: email.trim(),
        patientMobile: phoneNumber.trim(),
        date: aptDate,
        appointmentDate: aptDate,
        timeSlot: selectedSlot,
        appointmentTime: selectedSlot,
        symptoms: healthIssues.trim() || 'Not provided',
        healthIssues: healthIssues.trim() || 'Not provided',
        description: healthIssues.trim() || 'Not provided',
        medicalHistory: medHistory.trim() || 'None',
        currentMedications: curMeds.trim() || 'None',
        medications: curMeds.trim() || 'None',
        doctorId: bookingData.doctor.uid,
        doctorUID: bookingData.doctor.uid,
        doctorName: `Dr. ${bookingData.doctor.First} ${bookingData.doctor.Last}`,
        speciality: bookingData.doctor.Speciality || 'General Physician',
        clinicName: bookingData.doctor.ClinicName || "Doctor's Clinic",
        status: 'Confirmed',
        paymentStatus: 'Pending',
        paymentMethod: 'Not specified',
        bookingDate: new Date().toISOString(),
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        isGuestBooking,                       // flag so doctor panel can show guest badge
        accountAutoCreated: false,            // we never auto-create accounts now
        sharedDocuments: sharedDocs,
        hasSharedDocuments: sharedDocs.length > 0,
        sharedDocumentCount: sharedDocs.length,
      };

      // Always write to doctor's appointments node
      await set(ref(database, `doctor/${bookingData.doctor.uid}/appointments/${aptId}`), apt);

      // Write to user node — works for both real uids and guest ids
      await set(ref(database, `users/${activeUserId}/appointments/${aptId}`), apt);

      // For existing users, also update their profile info
      if (!isGuestBooking) {
        try {
          await update(ref(database, `users/${activeUserId}`), {
            name: patientName.trim(), email: email.trim(), mobile: phoneNumber.trim(),
            age: patientAge.trim(), updatedAt: new Date().toISOString(),
          });
        } catch (_) { /* non-critical */ }
      } else {
        // For new/guest users: create a minimal profile so we can track their appointment
        try {
          await set(ref(database, `users/${activeUserId}`), {
            userId: activeUserId,
            name: patientName.trim(),
            email: email.trim(),
            mobile: phoneNumber.trim(),
            age: patientAge.trim(),
            accountType: 'guest',
            createdAt: new Date().toISOString(),
            // hint: they can register later and link this guest id
            guestEmail: email.trim(),
          });
        } catch (_) { /* non-critical */ }
      }

      // Send confirmation email
      try {
        await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_CONFIRMATION_TEMPLATE_ID, {
          Patient_Email: email,
          Patient_Name: patientName,
          Doctor_Name: `Dr. ${bookingData.doctor.First} ${bookingData.doctor.Last}`,
          Apn_Date: bookingData.date.toLocaleDateString('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric'}),
          Apn_Time: selectedSlot,
          Doctor_Speciality: bookingData.doctor.Speciality,
          Clinic_Name: bookingData.doctor.ClinicName || "Doctor's Clinic",
          Appointment_ID: aptId,
          Booking_Date: new Date().toLocaleDateString('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric'}),
        }, EMAILJS_PUBLIC_KEY);
      } catch (error) {
        console.error('Appointment was booked, but the confirmation email failed:', error);
      }

      toast.success('🎉 Appointment booked successfully!');
      resetForm();
      onBookingComplete?.();
      setTimeout(() => handleModalClose(), 2000);
    } catch (e) {
      console.error(e);
      toast.error('Booking failed. Please try again.');
    } finally { setLoading(false); }
  };

  const resetForm = () => {
    setPatientName(''); setPatientAge(''); setPhoneNumber(''); setEmail('');
    setHealthIssues(''); setMedHistory(''); setCurMeds('');
    setSelectedSlot(''); setOtpSent(false); setOtp(['','','','','','']);
    setStep(1); setWantsToShare(null); setSelectedDocIds([]);
    setResolvedUserId(null); setAccountStatus(null);
  };

  const handleModalClose = () => { resetForm(); handleClose(); };
  const fmtDate = d => d?.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric',year:'numeric'}) || '';

  const pState = s => {
    const order=[1,2,3,3.5,4];
    const cur=order.indexOf(step), tgt=order.indexOf(s);
    if (tgt<cur) return 'done';
    if (tgt===cur) return 'active';
    return 'idle';
  };

  const STEPS = [{s:1,lbl:'Time'},{s:2,lbl:'Verify'},{s:3,lbl:'Details'},{s:3.5,lbl:'Docs'},{s:4,lbl:'Confirm'}];

  /* Account status banner */
  const AccountBanner = () => {
    if (!accountStatus) return null;
    const cfg = {
      // ✅ New user: friendly message, no mention of passwords or login
      new: {
        icon: '✅',
        text: 'OTP verified! You\'re booking as a new user. No login required — fill in your details below.',
      },
      existing: {
        icon: '👋',
        text: 'Welcome back! You\'ve been automatically logged in with your existing TrustDoctor account.',
      },
    };
    const { icon, text } = cfg[accountStatus] || {};
    if (!icon) return null;
    return (
      <div style={S.authBanner(accountStatus)}>
        <span style={{fontSize:16,flexShrink:0}}>{icon}</span>
        <span style={{fontWeight:600,lineHeight:1.4}}>{text}</span>
      </div>
    );
  };

  return (
    <Modal show={show} onHide={handleModalClose} centered dialogClassName="tsm-wrap">
      <div style={{display:'flex',flexDirection:'column',maxHeight:'calc(100dvh - 12px)',overflow:'hidden',borderRadius:14}}>

        {/* Header */}
        <div style={S.header} className="modal-header">
          <div style={{display:'flex',alignItems:'center',gap:10}}>
            <div style={S.avatar}>{bookingData?.doctor?.First?.charAt(0)||'D'}{bookingData?.doctor?.Last?.charAt(0)||'R'}</div>
            <div>
              <p style={S.docName}>Dr. {bookingData?.doctor?.First||''} {bookingData?.doctor?.Last||''}</p>
              <p style={S.docSpec}>{bookingData?.doctor?.Speciality||'General Physician'}</p>
            </div>
          </div>
          <button type="button" className="btn-close btn-close-white" onClick={handleModalClose} style={{marginLeft:'auto'}} />
        </div>

        {/* Scrollable Body */}
        <div style={S.body} className="tsm-body">

          {/* Progress */}
          <div style={S.progWrap}>
            {STEPS.map(({s,lbl}) => {
              const st = pState(s);
              return (
                <div key={s} style={S.progStep}>
                  <div style={S.circle(st)}>{st==='done'?'✓':STEPS.findIndex(x=>x.s===s)+1}</div>
                  <div style={S.circleLabel(st)}>{lbl}</div>
                </div>
              );
            })}
          </div>

          {/* ══ STEP 1: Time Slot ══ */}
          {step===1 && (
            <div style={S.card}>
              <div style={S.cardTitle}>Select Time Slot</div>
              <div style={S.highlight}>
                <strong style={{fontSize:12}}>Date:</strong> {bookingData?.date ? fmtDate(bookingData.date) : '—'}
                <div style={{marginTop:6}}>
                  <button onClick={onBack} style={{background:'none',border:'1px solid #bfdbfe',borderRadius:6,padding:'3px 10px',fontSize:11,color:'#1d4ed8',cursor:'pointer',fontWeight:600}}>← Change Date</button>
                </div>
              </div>
              {loadingSlots ? (
                <div style={{textAlign:'center',padding:24}}>
                  <Spinner animation="border" size="sm" variant="primary" />
                  <p style={{marginTop:8,color:'#6b7280',fontSize:12}}>Loading slots…</p>
                </div>
              ) : (
                <>
                  {allMorning.length>0 && (
                    <>
                      <div style={S.sessionBar}>🌅 Morning — {allMorning.filter(x=>!x.isBooked).length} available</div>
                      <div className="tsm-slots-grid" style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(82px,1fr))',gap:6,marginBottom:10}}>
                        {allMorning.map((sl,i)=>(
                          <button key={i} style={S.slot(selectedSlot===sl.value,sl.isBooked)} onClick={()=>!sl.isBooked&&setSelectedSlot(sl.value)} disabled={sl.isBooked}>
                            {sl.display}
                            {sl.isBooked && <div style={{fontSize:9,color:'#9ca3af',marginTop:2}}>Booked</div>}
                          </button>
                        ))}
                      </div>
                    </>
                  )}
                  {showBreak && allMorning.length>0 && allEvening.length>0 && <div style={S.breakBar}>⏸ Break Time</div>}
                  {allEvening.length>0 && (
                    <>
                      <div style={S.sessionBar}>🌆 Evening — {allEvening.filter(x=>!x.isBooked).length} available</div>
                      <div className="tsm-slots-grid" style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(82px,1fr))',gap:6,marginBottom:10}}>
                        {allEvening.map((sl,i)=>(
                          <button key={i} style={S.slot(selectedSlot===sl.value,sl.isBooked)} onClick={()=>!sl.isBooked&&setSelectedSlot(sl.value)} disabled={sl.isBooked}>
                            {sl.display}
                            {sl.isBooked && <div style={{fontSize:9,color:'#9ca3af',marginTop:2}}>Booked</div>}
                          </button>
                        ))}
                      </div>
                    </>
                  )}
                  {!allMorning.length && !allEvening.length && (
                    <div style={{background:'#fef9c3',border:'1px solid #fde68a',borderRadius:8,padding:'10px 12px',fontSize:12,color:'#854d0e'}}>
                      <strong>No slots available.</strong> Please try another date.
                    </div>
                  )}
                  {(allMorning.length>0||allEvening.length>0) && (
                    <div style={{textAlign:'center',marginTop:14}}>
                      <Button style={S.btnPrimary} onClick={()=>{if(!selectedSlot){toast.error('Select a slot');return;}setStep(2);}} disabled={!selectedSlot}>
                        Continue →
                      </Button>
                    </div>
                  )}
                </>
              )}
            </div>
          )}

          {/* ══ STEP 2: Contact + OTP ══ */}
          {step===2 && (
            <div style={S.card}>
              <div style={S.cardTitle}>Verify Contact</div>

              {/* ── Register promo banner — mobile friendly ── */}
              {!otpSent && (
                <>
                  {/* Register benefit banner */}
                  <div style={{
                    background: 'linear-gradient(135deg,#fffbeb,#fef9c3)',
                    border: '1.5px solid #fcd34d',
                    borderRadius: 10,
                    padding: '12px',
                    marginBottom: 10,
                    boxSizing: 'border-box',
                    width: '100%',
                  }}>
                    {/* Title */}
                    <div style={{display:'flex',alignItems:'flex-start',gap:8,marginBottom:8}}>
                      <span style={{fontSize:20,flexShrink:0,lineHeight:1}}>🌟</span>
                      <span style={{fontSize:13,fontWeight:700,color:'#92400e',lineHeight:1.4}}>
                        Want to save your appointment records?
                      </span>
                    </div>
                    {/* Benefits — row layout, no <ul> so no overflow on mobile */}
                    <div style={{marginBottom:10}}>
                      <div style={{fontSize:12,fontWeight:600,color:'#78350f',marginBottom:6}}>✅ Register to get these benefits:</div>
                      {[
                        {icon:'📋', text:'All appointments saved in one place'},
                        {icon:'🔔', text:'Reminders & alerts on your email'},
                        {icon:'📁', text:'Upload & share medical documents'},
                        {icon:'👤', text:'Profile pre-filled for future bookings'},
                      ].map(({icon,text}) => (
                        <div key={text} style={{display:'flex',alignItems:'center',gap:8,padding:'4px 0',borderBottom:'1px solid rgba(251,191,36,0.25)'}}>
                          <span style={{fontSize:14,flexShrink:0}}>{icon}</span>
                          <span style={{fontSize:11,color:'#78350f',lineHeight:1.4}}>{text}</span>
                        </div>
                      ))}
                    </div>
                    {/* Register button — full width, large tap target */}
                    <a
                      href="/register"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 8,
                        width: '100%',
                        boxSizing: 'border-box',
                        background: '#f59e0b',
                        color: '#fff',
                        fontWeight: 700,
                        fontSize: 13,
                        padding: '11px 14px',
                        borderRadius: 8,
                        textDecoration: 'none',
                        boxShadow: '0 2px 8px rgba(245,158,11,0.4)',
                        marginBottom: 6,
                        WebkitTapHighlightColor: 'transparent',
                      }}
                    >
                      📝 Click here to Register →
                    </a>
                    <div style={{textAlign:'center',fontSize:10,color:'#92400e',opacity:.7,fontStyle:'italic'}}>
                      Opens in a new tab
                    </div>
                  </div>

                  {/* Divider */}
                  <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:10}}>
                    <div style={{flex:1,height:1,background:'#e2e8f0'}} />
                    <span style={{fontSize:10,color:'#9ca3af',fontWeight:700,whiteSpace:'nowrap',letterSpacing:.3,textTransform:'uppercase'}}>
                      OR skip &amp; continue
                    </span>
                    <div style={{flex:1,height:1,background:'#e2e8f0'}} />
                  </div>

                  {/* No-login info */}
                  <div style={{background:'#f0fdf4',border:'1px solid #bbf7d0',borderRadius:8,padding:'8px 12px',marginBottom:12,fontSize:11,color:'#15803d',lineHeight:1.6}}>
                    ✅ <strong>No login required!</strong> Verify via OTP and book instantly.{' '}
                    Already have an account? You'll be recognised &amp; logged in automatically.
                  </div>
                </>
              )}

              {!otpSent ? (
                <>
                  <div style={S.highlight}><strong style={{fontSize:12}}>Slot:</strong> {fmtDate(bookingData?.date)}, {selectedSlot}</div>
                  {[
                    {label:'Patient Name *', val:patientName, set:setPatientName, err:nameError, type:'text', ph:'Full name'},
                    {label:'Mobile Number *', val:phoneNumber, set:setPhoneNumber, err:phoneError, type:'tel', ph:'10-digit mobile', maxLen:10},
                    {label:'Email Address *', val:email, set:setEmail, err:emailError, type:'email', ph:'your@email.com'},
                  ].map(({label,val,set,err,type,ph,maxLen})=>(
                    <div key={label} style={{marginBottom:12}}>
                      <label style={S.label}>{label}</label>
                      <input type={type} style={S.input} placeholder={ph} value={val} onChange={e=>set(e.target.value)} maxLength={maxLen} />
                      {err && <div style={S.err}>{err}</div>}
                    </div>
                  ))}
                  <Button style={S.btnPrimary} onClick={sendOTP} disabled={loading||!patientName||!phoneNumber||!email}>
                    {loading ? <><Spinner animation="border" size="sm" style={{marginRight:6}}/>Sending…</> : '📩 Send OTP'}
                  </Button>
                </>
              ) : (
                <div style={{textAlign:'center',padding:'10px 0'}}>
                  <p style={{fontSize:13,color:'#374151',marginBottom:4,fontWeight:600}}>Enter 6-digit OTP</p>
                  <p style={{fontSize:11,color:'#6b7280',marginBottom:16}}>Sent to <strong>{email}</strong></p>
                  <div className="tsm-otp-inputs" style={{display:'flex',justifyContent:'center',gap:10,marginBottom:16}}>
                    {otp.map((d,i)=>(
                      <input key={i} id={`tsm-otp-${i}`} type="text" maxLength={1}
                        style={{...S.input,width:44,height:44,textAlign:'center',fontSize:20,fontWeight:700,padding:0,borderRadius:8}}
                        value={d} onChange={e=>handleOtpChange(i,e.target.value)} onKeyDown={e=>handleOtpKey(i,e)} autoFocus={i===0} />
                    ))}
                  </div>
                  {loading ? (
                    <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:8,color:'#4285f4',fontSize:13,fontWeight:600}}>
                      <Spinner animation="border" size="sm" /> Verifying…
                    </div>
                  ) : (
                    <Button style={S.btnPrimary} onClick={verifyOTP} disabled={otp.join('').length!==6}>
                      Verify & Continue
                    </Button>
                  )}
                  <div style={{marginTop:12}}>
                    <button onClick={()=>setOtpSent(false)} style={{background:'none',border:'none',color:'#4285f4',fontSize:12,cursor:'pointer',textDecoration:'underline'}}>← Change Email/Phone</button>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* ══ STEP 3: Patient Details ══ */}
          {step===3 && (
            <div style={S.card}>
              <div style={S.cardTitle}>Patient Details</div>
              {/* ✅ Banner now shows correct message for new users (no login mention) */}
              <AccountBanner />
              <div style={S.highlight}><strong style={{fontSize:12}}>Slot:</strong> {fmtDate(bookingData?.date)}, {selectedSlot}</div>
              <div style={{marginBottom:12}}>
                <label style={S.label}>Patient Age *</label>
                <input type="number" style={S.input} placeholder="Age in years" value={patientAge} onChange={e=>setPatientAge(e.target.value)} min="0" max="150" />
                {ageError && <div style={S.err}>{ageError}</div>}
              </div>
              <div style={S.health}>
                <div style={{fontSize:13,fontWeight:700,color:'#c2410c',marginBottom:10}}>🏥 Health Information</div>
                {[
                  {lbl:'Current Issues / Reason for Visit',val:healthIssues,set:setHealthIssues,max:500,ph:'Fever, chest pain…'},
                  {lbl:'Medical History',val:medHistory,set:setMedHistory,max:500,ph:'Diabetes, hypertension…'},
                  {lbl:'Current Medications',val:curMeds,set:setCurMeds,max:300,ph:'Metformin 500mg…'},
                ].map(({lbl,val,set,max,ph})=>(
                  <div key={lbl} style={{marginBottom:10}}>
                    <label style={S.label}>{lbl}</label>
                    <textarea style={S.textarea} placeholder={ph} value={val} onChange={e=>set(e.target.value)} maxLength={max} />
                    <div style={{fontSize:10,color:'#9ca3af',textAlign:'right'}}>{val.length}/{max}</div>
                  </div>
                ))}
              </div>
              <div style={{fontSize:11,color:'#6b7280',marginTop:10,padding:'8px 10px',background:'#f8fafc',borderRadius:7}}>
                ✅ Verified: 📱 {phoneNumber} · 📧 {email}
              </div>
              <div style={{marginTop:14}}>
                <Button style={S.btnPrimary} onClick={confirmBooking} disabled={!patientAge}>Continue →</Button>
              </div>
            </div>
          )}

          {/* ══ STEP 3.5: Share Documents ══ */}
          {step===3.5 && (
            <div style={S.card}>
              <div style={S.cardTitle}>Share Medical Documents</div>
              <div style={S.shareBox}>
                <div style={S.shareTitle}>📁 Share documents with doctor?</div>
                <div style={S.shareSub}>Optionally share uploaded reports so the doctor can review them before your appointment.</div>

                {/* Guest users have no uploaded docs — skip sharing */}
                {resolvedUserId?.startsWith('guest_') ? (
                  <div style={{fontSize:12,color:'#6b7280',background:'#f8fafc',padding:'10px 12px',borderRadius:8,border:'1px dashed #e2e8f0'}}>
                    📂 Document sharing is available after creating your account. You can register from your profile after booking.
                  </div>
                ) : (
                  <>
                    {wantsToShare===null && (
                      <div className="tsm-share-btns" style={{display:'flex',gap:10}}>
                        <button style={{flex:1,padding:'10px',borderRadius:8,border:'1.5px solid #4285f4',background:'#4285f4',color:'#fff',fontWeight:700,fontSize:13,cursor:'pointer'}} onClick={()=>setWantsToShare(true)}>✅ Yes, share</button>
                        <button style={{flex:1,padding:'10px',borderRadius:8,border:'1.5px solid #e2e8f0',background:'#fff',color:'#6b7280',fontWeight:600,fontSize:13,cursor:'pointer'}} onClick={()=>{setWantsToShare(false);setSelectedDocIds([]);}}>❌ Skip</button>
                      </div>
                    )}
                    {wantsToShare===false && (
                      <div style={{display:'flex',alignItems:'center',gap:10}}>
                        <span style={{fontSize:12,color:'#6b7280'}}>No documents will be shared.</span>
                        <button onClick={()=>setWantsToShare(null)} style={{background:'none',border:'none',color:'#4285f4',fontSize:12,cursor:'pointer',textDecoration:'underline'}}>Change</button>
                      </div>
                    )}
                  </>
                )}
              </div>

              {wantsToShare===true && !resolvedUserId?.startsWith('guest_') && (
                <div>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
                    <span style={{fontSize:12,fontWeight:700,color:'#1e293b'}}>Select documents:</span>
                    <button onClick={()=>setWantsToShare(null)} style={{background:'none',border:'none',color:'#4285f4',fontSize:11,cursor:'pointer',textDecoration:'underline'}}>Cancel</button>
                  </div>
                  {loadingDocs ? (
                    <div style={{textAlign:'center',padding:20}}><Spinner animation="border" size="sm" /> <span style={{fontSize:12}}>Loading…</span></div>
                  ) : patientDocs.length===0 ? (
                    <div style={{textAlign:'center',padding:20,background:'#f8fafc',borderRadius:8,color:'#9ca3af',fontSize:12,border:'1px dashed #e2e8f0'}}>
                      <div style={{fontSize:28,marginBottom:6}}>📂</div>No documents uploaded yet.
                    </div>
                  ) : (
                    <>
                      <div style={{fontSize:11,color:'#6b7280',marginBottom:8}}>{selectedDocIds.length}/{patientDocs.length} selected</div>
                      {patientDocs.map(doc=>{
                        const sel=selectedDocIds.includes(doc.reportId);
                        return (
                          <div key={doc.reportId} style={S.docCard(sel)} onClick={()=>toggleDoc(doc.reportId)}>
                            <div style={{display:'flex',alignItems:'center',gap:10}}>
                              <span style={{fontSize:22}}>{fileIcon(doc.fileType,doc.fileName)}</span>
                              <div>
                                <div style={{fontSize:12,fontWeight:600,color:'#1e293b'}}>{doc.description||doc.fileName||'Document'}</div>
                                <div style={{fontSize:10,color:'#9ca3af'}}>
                                  {doc.fileName} {doc.fileSizeMB&&`· ${doc.fileSizeMB}MB`} {doc.uploadedAt&&`· ${new Date(doc.uploadedAt).toLocaleDateString()}`}
                                </div>
                              </div>
                            </div>
                            <div style={S.docCheck(sel)}>{sel?'✓':''}</div>
                          </div>
                        );
                      })}
                      {selectedDocIds.length>0 && (
                        <div style={{marginTop:8,padding:'8px 10px',background:'#f0fdf4',borderRadius:7,fontSize:11,color:'#15803d',fontWeight:600}}>
                          ✅ {selectedDocIds.length} doc{selectedDocIds.length>1?'s':''} will be shared
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}

              <div style={{marginTop:14}}>
                <Button style={S.btnPrimary} onClick={()=>setStep(4)}
                  disabled={!resolvedUserId?.startsWith('guest_') && wantsToShare===null}>
                  {wantsToShare&&selectedDocIds.length>0 ? `Share ${selectedDocIds.length} & Continue →` : 'Continue to Summary →'}
                </Button>
              </div>
            </div>
          )}

          {/* ══ STEP 4: Summary ══ */}
          {step===4 && (
            <div style={S.card}>
              <div style={S.cardTitle}>Appointment Summary</div>
              <AccountBanner />
              <div style={S.sumCard}>
                {[
                  {icon:'👨‍⚕️',title:'Doctor',rows:[
                    ['Doctor',`Dr. ${bookingData?.doctor?.First||''} ${bookingData?.doctor?.Last||''}`],
                    ['Speciality',bookingData?.doctor?.Speciality||'General Physician'],
                    ['Clinic',bookingData?.doctor?.ClinicName||"Doctor's Clinic"],
                  ]},
                  {icon:'📅',title:'Appointment',rows:[['Date',fmtDate(bookingData?.date)],['Time',selectedSlot]]},
                  {icon:'👤',title:'Patient',rows:[['Name',patientName],['Age',`${patientAge} yrs`],['Mobile',phoneNumber],['Email',email]]},
                ].map(({icon,title,rows})=>(
                  <div key={title} style={S.sumSec}>
                    <div style={S.sumTitle}>{icon} {title}</div>
                    {rows.map(([l,v])=>(
                      <div key={l} style={S.sumRow}><span style={S.sumLbl}>{l}</span><span style={S.sumVal}>{v}</span></div>
                    ))}
                  </div>
                ))}
                <div style={{...S.sumSec,borderBottom:'none',background:wantsToShare&&selectedDocIds.length?'#f0fdf4':'#fafafa'}}>
                  <div style={S.sumTitle}>📁 Documents</div>
                  {wantsToShare&&selectedDocIds.length>0 ? (
                    <>
                      <div style={{fontSize:11,color:'#15803d',fontWeight:600,marginBottom:6}}>✅ Sharing {selectedDocIds.length} doc{selectedDocIds.length>1?'s':''}</div>
                      {patientDocs.filter(d=>selectedDocIds.includes(d.reportId)).map(d=>(
                        <div key={d.reportId} style={{display:'flex',alignItems:'center',gap:6,fontSize:11,padding:'4px 0',borderBottom:'1px solid #f0f0f0'}}>
                          {fileIcon(d.fileType,d.fileName)} <span style={{fontWeight:600}}>{d.description||d.fileName}</span>
                          <span style={{background:'#dcfce7',color:'#16a34a',fontSize:10,fontWeight:700,padding:'1px 6px',borderRadius:10,border:'1px solid #bbf7d0'}}>Shared</span>
                        </div>
                      ))}
                    </>
                  ) : <div style={{fontSize:11,color:'#9ca3af'}}>No documents shared</div>}
                </div>
                {(healthIssues||medHistory||curMeds) && (
                  <div style={{...S.sumSec,borderBottom:'none',background:'#fff7ed'}}>
                    <div style={S.sumTitle}>🏥 Health Info</div>
                    {[['Issues',healthIssues],['History',medHistory],['Medications',curMeds]].filter(([,v])=>v).map(([l,v])=>(
                      <div key={l} style={{marginBottom:8}}>
                        <div style={{fontSize:11,color:'#6b7280',fontWeight:600,marginBottom:3}}>{l}:</div>
                        <div style={{fontSize:11,color:'#374151',background:'#fff',padding:'6px 8px',borderRadius:6}}>{v}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div style={{marginTop:14}}>
                <Button style={S.btnSuccess} onClick={finalizeBooking} disabled={loading}>
                  {loading ? <><Spinner animation="border" size="sm" style={{marginRight:6}}/>Booking…</> : '✅ Confirm & Book Appointment'}
                </Button>
              </div>
            </div>
          )}

        </div>{/* end scrollable body */}

        {/* Footer */}
        <div style={S.footer}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div>
              {step>1 && step<4 && (
                <button style={{background:'none',border:'1px solid #e2e8f0',borderRadius:7,padding:'6px 14px',fontSize:12,fontWeight:600,color:'#6b7280',cursor:'pointer'}}
                  onClick={()=>{
                    if (step===2&&otpSent) { setOtpSent(false); return; }
                    if (step===3.5) { setStep(3); return; }
                    setStep(s=>s-1);
                  }}>← Back</button>
              )}
            </div>
            <button style={{background:'none',border:'1px solid #fca5a5',borderRadius:7,padding:'6px 14px',fontSize:12,fontWeight:600,color:'#ef4444',cursor:'pointer'}}
              onClick={handleModalClose}>Cancel</button>
          </div>
        </div>

      </div>
    </Modal>
  );
};

export default TimeSlotModal;